import { EnvironmentProviders } from '@angular/core';

import { InjectionToken } from '@angular/core';

import { inject, Injector, makeEnvironmentProviders } from '@angular/core';
import {
  injectMFEEnvironment,
  provideCoreConfig,
} from '@embraceit/angularcore';
import { Environment } from './environment.model';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');

export function provideEnvironment(value: Environment): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: ENVIRONMENT,
      useValue: value,
    },
  ]);
}

export function injectEnvironment({ injector = inject(Injector) } = {}) {
  const sharedConfig = provideCoreConfig();
  if (sharedConfig.mode === 'standalone') {
    const environment = injector.get(ENVIRONMENT);
    return environment;
  }

  return injectMFEEnvironment('mls') as { [key: string]: string };
}
